"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonDeviceFilterFields = exports.ExtraField = void 0;
const effect_1 = require("effect");
const Device = __importStar(require("../../../device"));
exports.ExtraField = effect_1.Schema.Literal('ConnectionState', 'Alarms', 'FilterStatus', 'Co2Status', 'EnhancementsStatus');
/**
 * Query-param field schemas shared by all device-listing endpoints Each field is an
 * optional array (default: empty) or a 0-100 bounded number with defaults.
 *
 */
exports.CommonDeviceFilterFields = {
    include: exports.ExtraField,
    connectionState: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Class.Base.ConnectionState), {
        exact: true,
        default: () => [],
    }),
    installationStatus: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Class.Base.InstallationStatus), {
        exact: true,
        default: () => [],
    }),
    operatingMode: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Class.Base.OperatingMode), {
        exact: true,
        default: () => [],
    }),
    model: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Class.Common.ModelCode), {
        exact: true,
        default: () => [],
    }),
    ring: effect_1.Schema.optionalWith(Device.Class.Base.FilterableRing, { exact: true }),
    alarmTypes: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.AlarmTag), {
        exact: true,
        default: () => [],
    }),
    alarmSeverities: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.Severity), {
        exact: true,
        default: () => [],
    }),
    consumableLevelMin: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.between(0, 100)), {
        exact: true,
        default: () => 0,
    }),
    consumableLevelMax: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.between(0, 100)), {
        exact: true,
        default: () => 100,
    }),
};
//# sourceMappingURL=device-filters.js.map